import { gql } from '@apollo/client'
import { useSearch } from '@btime/react-contexts'
import React from 'react'

import { triggersClient } from '../../../../../../utils/apollo/api'
import StatePresenter from '../../../../../../packages/kiti/components/helpers/StatePresenter'
import { usePaginatedQuery } from '../../../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../../../packages/kiti/components/helpers/LazyAction'
import { useServiceOrderState } from '../../../_load/ServiceOrderLoader'

const Context = React.createContext()
const { Provider } = Context
export const useTriggerCallsState = () => React.useContext(Context) || {}
export const useTriggerCalls = () => useTriggerCallsState()?.triggerCalls || []

const QUERY = gql`
  query TriggerCalls($page: Int, $search: String, $sort: TriggerCallSort, $filter: TriggerCallFilter) {
    triggerCalls(page: $page, search: $search, sort: $sort, filter: $filter) {
      id
      status
      triggerId
      entityType
      entityId
      data
      updatedAt
    }
  }
`

const TriggerCallsLoader = ({ children, uncontrolledChildren }) => {
  const search = useSearch()
  const { serviceOrder } = useServiceOrderState()

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search,
      sort: { field: 'UPDATED_AT', type: 'DESC' },
      filter: {
        entityType: ['event', 'service_order'],
        status: ['error'],
        data: JSON.stringify({ record: { service_order: { id: serviceOrder.id } } })
      }
    },
    client: triggersClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} />
      </StatePresenter>
    </Provider>
  )
}

export default TriggerCallsLoader
